<div class="workflow-card">
  <!-- Top Info Section -->
  <!-- <div class="top-info">
    <div class="left">
      <div class="heading">
        <span
          [matTooltip]="activity?.activityName || '—'"
          matTooltipPosition="above"
        >
          {{ activity?.activityName || "—" }}
        </span>
      </div>
      <div class="subtext">
        <span
          [matTooltip]="(activity?.pssName || '—') + ' - v' + (activity?.version || '—')"
          matTooltipPosition="above"
        >
          {{ activity?.pssName || "—" }} - v({{ activity?.version || "—" }})
        </span>
      </div>
    </div>

    <div class="right">
      <div class="heading">
        <span matTooltip="Review Activity">Review Activity</span>
      </div>
      <div class="subtext">
        <span
          [matTooltip]="'Reviewing By - ' + (activity?.assignee || '—')"
          matTooltipPosition="above"
        >
          Reviewing By - {{ activity?.assignee || "—" }}
        </span>
      </div>
    </div>
  </div> -->
  <!-- Child Content -->

<app-report-analysis
app-report-analysis
  *ngIf="showReportAnalysis"
  [reportTemplateId]="reportTemplateId"
  [instancedetailid]="instancedetailid"
  (back)="goBack()"
   [selectedActivity]="activity"
  (next)="openAssessment($event)">
</app-report-analysis>
<app-assessment
  *ngIf="!showReportAnalysis && !showAlertSummary"
  [scheduleId]="activity.scheduleId"
  [uploadInstructions]="activity.uploadInstructions"
  [evidenceRequired]="activity.evidenceRequired"
  [isOverdue]="activity.isOverdue"
  (back)="backToReports()"
  (assesementComplete)="goBack()">
</app-assessment>
<app-alert-mapping-quicksight *ngIf="showAlertSummary && !showReportAnalysis"
[navigatedFrom]="'ReviewActivity'"
(back)="goBack()"
 (next)="openAssessment($event)"
></app-alert-mapping-quicksight>

</div>
